import styled from 'styled-components';
import { Modal as CommonModal } from '#molecules';

export const Modal = styled(CommonModal)`
  border-radius: 20px;
`;

export const Container = styled.div`
  width: 100%;
`;

export const ModalTitle = styled.div`
  margin-bottom: 28px;
  text-align: left;
  margin-right: auto;
  color: #d7d3de;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.38px;
`;

export const ButtonBox = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
  margin-top: 25px;
`;

export const ScrollWrapper = styled.div`
  display: flex;
  max-width: 270px;
  margin: 0 auto;
`;

export const Divider = styled.div`
  margin: 0 12px;
  width: 1px;
  height: 106px;
  background-color: #413d50;
`;
